import axios from 'axios'
import { Modal, message } from 'ant-design-vue'
import md5 from 'crypto-js/md5'
import qs from 'qs'
import store from '@/store'
import {getToken, getSiteInfo, getRefreshToken} from '@/utils/storage'
import { encrypt } from "@/utils/cryptoAes";
import { getRandomString } from '@/utils/tools'
const service = axios.create({
    baseURL: process.env.VUE_APP_SERVICE_BASE,
    timeout: 30000
})
const getHeader = (refreshToken) => {
    let timestamp = new Date().valueOf()
    let token = store.state.token ? getToken() : null
    if(refreshToken) token = getRefreshToken()
    let uuid = store.state.site_info ? getSiteInfo().uuid : null
    let nonce = getRandomString(16)
    let header = {
        'X-nonce': nonce,
        'X-timestamp': timestamp
    }
    if(token) header["Bbs-token"] = token
    if(uuid) header["X-uuid"] = uuid
    header['X-sign'] = encrypt(md5(qs.stringify(header, {encode: false})).toString())
    return header
}
// 请求队列
let request_list = []

// 请求拦截器
service.interceptors.request.use(
    config => {
        let header = getHeader()
      request_list.push(1)
        config.headers = Object.assign({},config.headers,header)
        if (config.method === 'post'){
            if(config.data && config.data.file && config.data.file instanceof File){
                config.headers['Content-Type'] = 'multipart/form-data'
                let formData = new FormData()
                for(let i in config.data){
                    formData.append(i, config.data[i])
                }
                config.data = formData
            }else{
                config.headers['Content-Type'] = 'application/json'
            }
        }
        return config
    },
    error => {
        if(process.env.NODE_ENV === 'development') console.log(error)
        return Promise.reject(error)
    }
)
// 响应拦截器
// 是否正在刷新的标记
let isRefreshing = false
//重试队列
let requests = []
let dialogLock = false
service.interceptors.response.use(
    response => {
        const config = response.config
        const res = response.data
        request_list.pop()
        if (res.code === 20000) return res
        if (res.code === 50008) {
          // to refreshing token
          if(isRefreshing && response.request.responseURL.indexOf('bbsUserAuth/refreshBbsToken') !== -1) return Promise.reject(new Error(res.message || 'Error'))
          if(isRefreshing) {
            return new Promise(resolve => {
              requests.push(() => {
                resolve(service(config))
              })
            })
          }
          if(!isRefreshing){
            isRefreshing = true
            //更换token进行请求
            if(store.state.refresh_token){
              store.commit('SET_TOKEN',{token: store.state.refresh_token})
            }
            return store.dispatch('resetToken').then(() => {
              let header = getHeader()
              config.headers = Object.assign({},config.headers,header)
              let timer = setInterval(() => {
                if(request_list.length === 0){
                  clearInterval(timer)
                  requests.forEach(cb => cb())
                  isRefreshing = false
                  requests = []
                }
              },10)
              return service(config)
            }).catch(() => {
              isRefreshing = false
              if(!dialogLock) {
                dialogLock = true
                Modal.info({
                  title: '登录已过期，请重新登录',
                  onOk() {
                    store.commit('RESET_STATE')
                    store.commit('REMOVE_TOKEN')
                    location.reload()
                  }
                })
              }
            })
          } else {
            if(response.request.responseURL.indexOf('bbsUserAuth/refreshBbsToken') !== -1) return Promise.reject(new Error(res.message || 'Error'))
            return new Promise(resolve => {
              requests.push((config) => {
                resolve(service(config))
              })
            })
          }
        } else{
          message.error(res.message || 'Error',5)
          return Promise.reject(new Error(res.message || 'Error'))
        }
    },
    error => {
        if(process.env.NODE_ENV === 'development') console.log('err' + error) // for debug
        message.error(error.message,5)
        return Promise.reject(error)
    }
)

export default service
